"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublicPurchaseService = void 0;
class PublicPurchaseService {
}
exports.PublicPurchaseService = PublicPurchaseService;
//# sourceMappingURL=purchase.js.map